export class IndividualPrefixLang {
    public Dr: string;
    public Miss: string;
    public Mr: string;
    public Ms: string;
    public None: string;
    public Prof: string;
}


// WEBPACK FOOTER //
// ./src/resources/IndividualPrefixLang.ts